/**
 * KAHVE KAVURMA MERKEZİ — Tadım Seti Wizard
 * 4 Adım: TÜR → ÇEKİRDEK (5 adet, 100gr) → ÖĞÜTME → ÖNİZLEME
 * Fiyat: Shopify'dan dinamik çekilir (siparisVariantId)
 */
'use strict';

const TADIM_COUNT = 5;
const TADIM_GR    = 100;

class TadimWizard {
  constructor(cfg) {
    this.cfg     = cfg;
    this._s      = { step:0, type:'filtre', beans:[], grind:'cekirdek' };
    this.catalog = [];
    this._price  = 0; // Shopify'dan çekilecek
    this._priceFormatted = '—';
    this._init();
  }

  async _init() {
    document.addEventListener('click', e => this._click(e));
    await Promise.all([this._loadBeans(), this._loadPrice()]);
    this._goStep(2);
  }

  async _loadPrice() {
    const vid = window.TADIM_CONFIG?.siparisVariantId;
    if (!vid) return;
    try {
      // Shopify product.js endpoint ile variant fiyatını çek
      const r = await fetch(`/products/${vid}.js`, { cache:'no-store' }).catch(() => null);
      // Eğer handle bilinmiyorsa, variant id üzerinden cart/add-dry-run yöntemi yerine
      // doğrudan /variants/{id}.js çalışmadığından, search endpoint kullan:
      if (!r || !r.ok) {
        await this._loadPriceViaSearch(vid);
        return;
      }
    } catch(e) {
      await this._loadPriceViaSearch(vid);
    }
  }

  async _loadPriceViaSearch(vid) {
    try {
      // Shopify'ın genel ürün arama/AJAX API'si üzerinden variant fiyatı çekilemez doğrudan;
      // en güvenilir yol: cart/add.js ile dry-run yapmadan, /cart.js üzerinden değil,
      // /products.json üzerinden variant id eşleştirmesi yapmak.
      const r = await fetch('/products.json?limit=250', { cache:'no-store' });
      if (!r.ok) return;
      const data = await r.json();
      const products = data.products || [];
      for (const p of products) {
        const variant = (p.variants || []).find(v => String(v.id) === String(vid));
        if (variant) {
          this._price = parseFloat(variant.price) || 0;
          this._priceFormatted = new Intl.NumberFormat('tr-TR', { style:'currency', currency: this.cfg.currency || 'TRY', maximumFractionDigits:0 }).format(this._price);
          this._updatePriceUI();
          return;
        }
      }
    } catch(e) {}
  }

  _updatePriceUI() {
    document.querySelectorAll('.kw-tadim-price').forEach(el => {
      el.textContent = this._priceFormatted;
    });
  }

  async _loadBeans() {
    try {
      const r = await fetch('https://admin.kahvekavurmamerkezi.com/?beans', { cache:'no-store' });
      if (!r.ok) return;
      const data = await r.json();
      if (!data || !Object.keys(data).length) return;
      this.catalog = Object.entries(data).map(([id, b]) => ({
        id:         String(id),
        variantId:  String(b.variantId || ''),
        title:      b.title || '',
        color:      b.renk  || '#7D4A2A',
        tatNotlari: b.tat   || '',
        mensei:     b.mensei|| '',
        rakim:      b.rakim || '',
        proses:     b.proses|| '',
        tur:        b.tur   || '',
        foto:       b.foto  || '',
        bayrak:     b.bayrak|| '',
        stockGr:    (parseFloat(b.stock) >= 0 ? parseFloat(b.stock) : 9999) * 1000,
        price:      parseFloat(b.price) || 0,
      })).filter(c => c.stockGr > 0);
    } catch(e) {}
  }

  _goStep(n) {
    document.querySelectorAll('.kw-step').forEach(el => {
      el.style.display = el.dataset.stepPanel == n ? 'block' : 'none';
    });
    document.querySelectorAll('.kw-step-nav__item').forEach(el => {
      const s = parseInt(el.dataset.step);
      el.classList.toggle('active', s === n);
      el.classList.toggle('done',   s < n);
    });
    const visibleStep = n - 1;
    const fill = document.getElementById('kw-progress-fill');
    if (fill) fill.style.width = (visibleStep / (this.cfg.totalSteps - 1) * 100) + '%';
    this._s.step = n;
    if (n === 2) this._renderStep2();
    if (n === 4) this._renderStep4();
    this._navBtns();
    this._updatePriceUI();
  }

  next() { if (!this._valid()) return; this._goStep(4); }
  back() { if (this._s.step <= 2) return; this._goStep(2); }

  _valid() {
    if (this._s.step === 2) return this._s.beans.length === TADIM_COUNT;
    return true;
  }

  _navBtns() {
    const valid = this._valid();
    const nb = document.getElementById('kw-btn-next');
    if (nb) nb.disabled = !valid;
    const b2 = document.getElementById('kw-btn-buynow2');
    const b3 = document.getElementById('kw-btn-cart2');
    if (b2) b2.disabled = !valid;
    if (b3) b3.disabled = !valid;
    const toggle  = document.getElementById('kw-summary-toggle');
    const summary = document.getElementById('kw-summary');
    if (toggle && summary && !toggle.dataset.bound) {
      toggle.dataset.bound = '1';
      toggle.addEventListener('click', () => summary.classList.toggle('kw-summary--open'));
    }
  }

  _click(e) {
    const t = e.target;
    if (t.closest('#kw-btn-next'))     { this.next(); return; }
    if (t.closest('#kw-btn-back'))     { this.back(); return; }
    if (t.closest('#kw-btn-cart'))     { this.addToCart(false); return; }
    if (t.closest('#kw-btn-buynow'))   { this.addToCart(true);  return; }
    if (t.closest('#kw-btn-cart2'))    { this.addToCart(false); return; }
    if (t.closest('#kw-btn-buynow2'))  { this.addToCart(true);  return; }
    const card = t.closest('[data-kw-group]');
    if (card) this._cardClick(card);
  }

  _cardClick(card) {
    const group = card.dataset.kwGroup;
    const val   = card.dataset.kwValue;
    if (group === 'bean') this._toggleBean(val);
  }

  _toggleBean(id) {
    const idx = this._s.beans.indexOf(id);
    if (idx !== -1) {
      this._s.beans.splice(idx, 1);
      document.querySelector(`[data-kw-group="bean"][data-kw-value="${id}"]`)?.classList.remove('selected');
    } else {
      if (this._s.beans.length >= TADIM_COUNT) {
        const removed = this._s.beans.shift();
        document.querySelector(`[data-kw-group="bean"][data-kw-value="${removed}"]`)?.classList.remove('selected');
      }
      this._s.beans.push(id);
      document.querySelector(`[data-kw-group="bean"][data-kw-value="${id}"]`)?.classList.add('selected');
    }
    this._updateBeanCounter();
    this._navBtns();
  }

  _updateBeanCounter() {
    const el = document.getElementById('kw-bean-count');
    const n    = this._s.beans.length;
    const left = TADIM_COUNT - n;
    if (el) {
      if (n === TADIM_COUNT) {
        el.textContent = `${TADIM_COUNT} çekirdek seçildi ✓`;
        el.style.color = '#27ae60';
      } else {
        el.textContent = `${n} / 5 — ${left} çekirdek daha seçin`;
        el.style.color = '#9A8968';
      }
    }
    const list = document.getElementById('kw-tadim-bean-list');
    if (list) {
      if (!n) {
        list.innerHTML = '<p style="font-size:12px;color:var(--kw-muted);">Henüz çekirdek seçilmedi.</p>';
      } else {
        const beanObjs = this._s.beans.map(id => this.catalog.find(c => c.id === id)).filter(Boolean);
        list.innerHTML = beanObjs.map((b, i) => `
          <div style="display:flex;align-items:center;gap:8px;padding:5px 0;border-bottom:1px solid var(--kw-line);font-size:12px;">
            <span style="font-size:10px;font-weight:700;color:var(--kw-taupe);width:14px;">${i+1}</span>
            <span style="width:8px;height:8px;border-radius:50%;background:${b.color};flex-shrink:0;"></span>
            <span style="flex:1;color:var(--kw-dark);">${b.title}</span>
          </div>`).join('');
      }
    }
  }

  _renderStep2() {
    const g = document.getElementById('kw-beans-grid');
    if (!g) return;
    if (!this.catalog.length) {
      g.innerHTML = '<p style="grid-column:1/-1;color:#9A8968;padding:20px 0;">Çekirdekler yükleniyor...</p>';
      this._loadBeans().then(() => this._renderStep2());
      return;
    }
    const CO = {'Brasil':0,'Santos':0,'Ethiopia':1,'Etiyopya':1,'Colombia':2,'Kenya':3,'Rwanda':4,'El Salvador':5,'Honduras':6,'Uganda':7,'Peru':8};
    const sorted = [...this.catalog].sort((a,b)=>{
      const ga=Object.entries(CO).find(([k])=>a.title.includes(k));
      const gb=Object.entries(CO).find(([k])=>b.title.includes(k));
      return (ga?ga[1]:99)-(gb?gb[1]:99);
    });
    g.innerHTML = sorted.map(c => {
      const selected   = this._s.beans.includes(c.id);
      const outOfStock = c.stockGr <= 0;
      const cardStyle  = outOfStock ? 'opacity:.5;pointer-events:none;' : '';
      const priceLbl   = c.price > 0
        ? `<span style="position:absolute;bottom:8px;left:8px;background:rgba(255,255,255,.92);font-size:11px;font-weight:700;padding:3px 9px;">${new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',maximumFractionDigits:0}).format(c.price)}<small>/kg</small></span>`
        : '';
      const stockBadge = outOfStock
        ? `<span style="position:absolute;top:6px;right:6px;background:#c0392b;color:#fff;font-size:9px;padding:2px 6px;font-weight:700;">STOK YOK</span>`
        : '';
      const vis = c.foto
        ? `<img src="${c.foto}" alt="${c.title}" style="width:100%;height:100%;object-fit:cover;">`
        : c.bayrak
          ? `<img src="https://flagcdn.com/w320/${c.bayrak}.png" alt="" style="width:100%;height:100%;object-fit:cover;filter:sepia(30%) saturate(80%);">`
          : `<div style="width:100%;height:100%;background:${c.color};"></div>`;
      return `<div class="kw-bean-card${selected?' selected':''}" data-kw-group="bean" data-kw-value="${c.id}" style="${cardStyle}">
        <div class="kw-bean-card__visual" style="position:relative;overflow:hidden;background:#fff;">${vis}${priceLbl}${stockBadge}</div>
        <div class="kw-bean-card__body">
          <strong>${c.title}</strong>
          <span class="kw-bean-origin">${c.mensei}</span>
          <span class="kw-bean-notes">${c.tatNotlari}</span>
          <div class="kw-bean-tags">
            <span class="kw-tag">${c.rakim}</span>
            <span class="kw-tag">${c.proses}</span>
            ${c.tur?`<span class="kw-tag">${c.tur}</span>`:''}
          </div>
        </div>
      </div>`;
    }).join('');
    this._s.beans.forEach(id => {
      document.querySelector(`[data-kw-group="bean"][data-kw-value="${id}"]`)?.classList.add('selected');
    });
    this._updateBeanCounter();
  }

  _renderStep4() {
    const el = document.getElementById('kw-preview');
    if (!el) return;
    const beanObjs = this._s.beans.map(id => this.catalog.find(c => c.id === id)).filter(Boolean);
    el.innerHTML = `
      <div class="kw-preview-card">
        <div class="kw-preview-row"><span>Kavurma Profili</span><strong>Medium (Standart)</strong></div>
        <div class="kw-preview-row"><span>Seçilen Çekirdekler</span><strong>${beanObjs.length} çekirdek</strong></div>
        <div class="kw-preview-row"><span>Toplam Ağırlık</span><strong>5 × 100 gr = 500 gr</strong></div>
        <div class="kw-preview-row"><span>Toplam Fiyat</span><strong class="kw-tadim-price">${this._priceFormatted}</strong></div>
      </div>
      <div style="margin-top:20px;">
        <div class="kw-section-label" style="margin-bottom:10px;">SEÇİLEN ÇEKİRDEKLER</div>
        ${beanObjs.map((c,i) => `
          <div style="display:flex;align-items:center;gap:12px;padding:10px 0;border-bottom:1px solid var(--kw-line);">
            <span style="font-size:10px;font-weight:700;color:var(--kw-taupe);width:18px;">${i+1}</span>
            <span style="width:14px;height:14px;background:${c.color};display:inline-block;flex-shrink:0;border:1px solid rgba(0,0,0,.08);"></span>
            <div style="flex:1;min-width:0;">
              <div style="font-size:13px;font-weight:600;color:#3A3028;">${c.title}</div>
              <div style="font-size:11px;color:#9A8968;">${c.mensei}</div>
            </div>
            <span style="font-size:11px;font-weight:600;color:#8A7A62;">100 gr</span>
          </div>`).join('')}
      </div>`;
  }

  /* ── Sepete Ekle ── */
  _cartLoading(show) {
    let ov = document.getElementById('kw-cl');
    if (show) {
      if (!ov) {
        ov = document.createElement('div');
        ov.id = 'kw-cl';
        ov.style.cssText = 'position:fixed;inset:0;background:rgba(28,24,18,.45);z-index:99999;display:flex;align-items:center;justify-content:center;';
        ov.innerHTML = '<div style="width:44px;height:44px;border:3px solid rgba(255,255,255,.2);border-top-color:#fff;border-radius:50%;animation:kwSpin .7s linear infinite;"></div>';
        if (!document.getElementById('kw-sp')) {
          const st = document.createElement('style');
          st.id = 'kw-sp';
          st.textContent = '@keyframes kwSpin{to{transform:rotate(360deg)}}';
          document.head.appendChild(st);
        }
        document.body.appendChild(ov);
      }
      ov.style.display = 'flex';
      ['kw-btn-cart','kw-btn-buynow','kw-btn-cart2','kw-btn-buynow2'].forEach(id => {
        const b = document.getElementById(id); if (b) b.disabled = true;
      });
    } else {
      if (ov) ov.style.display = 'none';
      const valid = this._valid();
      ['kw-btn-cart','kw-btn-buynow','kw-btn-cart2','kw-btn-buynow2'].forEach(id => {
        const b = document.getElementById(id); if (b) b.disabled = !valid;
      });
    }
  }

  async addToCart(buyNow = false) {
    this._cartLoading(true);
    const SIPARIS_VID = window.TADIM_CONFIG?.siparisVariantId || null;
    if (!SIPARIS_VID) { this._cartLoading(false); alert('Ürün yapılandırılmamış.'); return; }

    const beanObjs = this._s.beans.map(id => this.catalog.find(c => c.id === id)).filter(Boolean);
    const group    = 'TADIM-' + Date.now();

    const props = { '_group': group, '_label': 'tadim' };
    beanObjs.forEach((c, i) => {
      props[`Çekirdek ${i+1}`] = `${c.title} — 100 gr`;
    });

    const item = {
      id:         parseInt(SIPARIS_VID),
      quantity:   1,
      properties: props,
    };

    try {
      if (buyNow) {
        await fetch('/cart/clear.js', { method: 'POST' });
        const rb = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] }),
        });
        if (!rb.ok) throw new Error(await rb.text());
        const f = document.createElement('form');
        f.method = 'POST'; f.action = '/checkout';
        document.body.appendChild(f); f.submit();
      } else {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] }),
        });
        if (!r.ok) throw new Error(await r.text());
        const drawerComp = document.querySelector('cart-drawer-component');
        if (drawerComp) {
          try {
            const cart = await fetch('/cart.js', {cache:'no-store'}).then(r=>r.json());
            const sectionsRes = await fetch('/cart?sections=cart-drawer', {cache:'no-store'});
            const sectionsData = await sectionsRes.json();
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, data: { sections: sectionsData, source: 'tadim-wizard', item_count: cart.item_count } }
            }));
            await new Promise(r=>setTimeout(r,300));
            if (typeof drawerComp.open === 'function') drawerComp.open();
          } catch {}
        } else {
          sessionStorage.setItem('kw_open_cart', '1');
          window.location.reload();
        }
      }
    } catch(err) {
      alert('Hata: ' + err.message);
    } finally {
      this._cartLoading(false);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.tadimWizard = new TadimWizard(window.TADIM_CONFIG || { totalSteps:3 });
  if (sessionStorage.getItem('kw_open_cart')) {
    sessionStorage.removeItem('kw_open_cart');
    setTimeout(() => {
      const btn = document.querySelector('button[aria-label="Sepet"], button[aria-label="Cart"]');
      if (btn) btn.click();
    }, 800);
  }
});